<template>
  <Base :is-loading="dataIsLoad" :base-id="'lb-order-transport'">
    <template #header>
      <h4 class="modal-title">物流追蹤</h4>
    </template>
    <template #body>
      <ol class="progress-approval">
        <li v-for="(progress, index) in data" :key="index" class="progress-step">
          <div class="approver">
            <div class="h5">{{ progress.ShippingFlowDescription }}</div>
            <div class="h6">{{ progress.Date }}</div>
          </div>
        </li>
      </ol>
    </template>
    <template #footer>
      <button type="button" class="btn btn-sm" @click.prevent="closeModal">確定</button>
    </template>
  </Base>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';

import useModalStore from '@global/stores/useModalStore';
import useShippingProgress from '@global/composable/order/useShippingProgress';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const { data, dataIsLoad, fetchAPI } = useShippingProgress({
  transactionId: modalData.value.id,
  wmstransactionId: modalData.value.wid,
});

onMounted(() => {
  fetchAPI();
});
</script>
